import { render, staticRenderFns } from "./PackagesReport.vue?vue&type=template&id=59eb6a6c&scoped=true"
import script from "./PackagesReport.vue?vue&type=script&lang=js"
export * from "./PackagesReport.vue?vue&type=script&lang=js"
import style0 from "./PackagesReport.vue?vue&type=style&index=0&id=59eb6a6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59eb6a6c",
  null
  
)

export default component.exports